import axiosService from '@services/axiosService';

export const logError = (err) => axiosService.post('/api/error-logger', err);



// WEBPACK FOOTER //
// ./services/errorLoggerResource.js